import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Credential } from '../model/Credentials.model';
import { URL_API } from './url.api';
import { StorageService } from './storage.service';
import { LocalUser } from '../model/localUser.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  jwtHelper = new JwtHelperService();

  H

 constructor(
    private http: HttpClient,
    private storage: StorageService,
    private router: Router
  ) { 
  }

  login(credentials: Credential) {
    return this.http.post(`${URL_API}/login`,
      credentials,
      { observe: 'response', responseType: 'text' });
  }

  refreshToken() {
    return this.http.post(`${URL_API}/auth/refreshToken`,
      { observe: 'response', responseType: 'text' });
  }

  successLogin(authorizationToken: string) {
    let tok = authorizationToken.substring(7);
    let user: LocalUser = {
      token: tok,
      username: this.jwtHelper.decodeToken(tok).sub
    }
    this.storage.setLocalUser(user);
  }

  tokenExpired(token: string): boolean {
    return this.jwtHelper.isTokenExpired(token);
  }

  logout() {
    this.router.navigate(['login']);
    localStorage.clear();
  }
}
